import {rootAction} from "../apiAction";

export const REQUEST_CREATE_NEW_REQUEST = 'REQUEST_CREATE_NEW_REQUEST';
export const SUCCESS_CREATE_NEW_REQUEST = 'SUCCESS_CREATE_NEW_REQUEST';
export const FAILURE_CREATE_NEW_REQUEST = 'FAILURE_CREATE_NEW_REQUEST';
export const CLEAR_NEW_REQUEST = 'CLEAR_NEW_REQUEST'

export const REQUEST_SEND_SIGNED_REQUEST = 'REQUEST_SEND_SIGNED_REQUEST';
export const SUCCESS_SEND_SIGNED_REQUEST = 'SUCCESS_SEND_SIGNED_REQUEST';
export const FAILURE_SEND_SIGNED_REQUEST = 'FAILURE_SEND_SIGNED_REQUEST';
export const CLEAR_SIGNED_REQUEST_INFO = 'CLEAR_SIGNED_REQUEST_INFO'

export const createNewRequest = (data) => dispatch => {
    return dispatch(rootAction(
        'POST',
        `/notary/package`,
      data,
        {
            request: REQUEST_CREATE_NEW_REQUEST,
            success: SUCCESS_CREATE_NEW_REQUEST,
            failure: FAILURE_CREATE_NEW_REQUEST
        },
      {
        'Content-Type': 'application/json'
      },
      300000
    ));
}

export const clearNewRequest = () => dispatch => {
  return dispatch({
      type: CLEAR_NEW_REQUEST
    }
  )
};

export const sendSignedRequests = (data) => dispatch => {
  return dispatch(rootAction(
    'POST',
    `/notary/processSignedPackage`,
    data,
    {
      request: REQUEST_SEND_SIGNED_REQUEST,
      success: SUCCESS_SEND_SIGNED_REQUEST,
      failure: FAILURE_SEND_SIGNED_REQUEST
    },
    {
      'Content-Type': 'application/json'
    },
    300000

  ));
}

export const clearSignedRequestInfo = () => dispatch => {
  return dispatch({
      type: CLEAR_SIGNED_REQUEST_INFO
    }
  )
};
